/* eslint-disable no-param-reassign */
/** @jsxImportSource @emotion/react */
import { memo, MouseEvent } from 'react';

import { S3_RESOURCE_ICONS } from '../../constants';

import * as styles from './Icon.style';

export interface IconProps {
  className?: string;
  baseUrl?: string;
  name: string; // S3 Icon name
  hover?: string;
  alt?: string;
  onClick?: (event: MouseEvent) => void;
}

function Icon({
  className,
  name,
  baseUrl = S3_RESOURCE_ICONS,
  alt = 'icon',
  hover,
  onClick,
}: IconProps) {
  function handleMouseEnter({ currentTarget }: React.MouseEvent<HTMLImageElement>) {
    if (hover) {
      currentTarget.src = `${baseUrl}/${hover}.svg`;
    }
  }

  function handleMouseLeave({ currentTarget }: React.MouseEvent<HTMLImageElement>) {
    currentTarget.src = `${baseUrl}/${name}.svg`;
  }

  return (
    <img
      className={className}
      css={[styles.icon, onClick && styles.clickable]}
      src={`${baseUrl}/${name}.svg`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      alt={alt || name}
      onClick={onClick}
    />
  );
}

export default memo(Icon);
